module.exports = __webpack_public_path__ + "img/logo-header2.3f712b89.png";